import { render } from "./pro-tip-listing.vue?vue&type=template&id=6b091a5b"
import script from "./pro-tip-listing.vue?vue&type=script&lang=js"
export * from "./pro-tip-listing.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\MVC\\wwwroot\\Frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__